//导入模块
import Vue from 'vue';
import VueRouter from 'vue-router';
import index from "@/views/index";
import Login from "@/views/Login";
//注册路由组件
Vue.use(VueRouter);
//编写路由规则
const routes = [
  {
    path: "/",
    name: 'Login',
    component: Login
  },
  {
    path: "/index",
    name: 'index',
    component: index
  },
]
//创建路由
const router = new VueRouter({
  mode: 'history',
  routes
})
//导出
export default router;